<template lang="pug">
  #RepuestosRecibidosEjecutivo
    b-button(
      variant="action"
      @click="openModal"
    )
      | Repuestos Recibidos Ejecutivo
    //- Modal para confirmar rechazo
    b-modal.hide-footer(v-model="showModal"  no-close-on-backdrop, title="Recibir repuestos Ejecutivo")
      p.center Vas a recibir los siguientes repuestos.
      p.center Por favor confirma que son correctos.
      div.mt-4.d-flex.align-items-center
        <font-awesome-icon :icon="['fa', 'tools']" />
        span.title.ml-2 Repuestos
      table.table.mt-0
        thead
          tr
            th N° de Parte
            th.descripcion Descripción
            th.cantidad Cantidad
        tbody
          tr(v-for="(repuesto, index) in repuestosParaRecibir" :key="index")
            td {{ repuesto.parte.part_number }}
            td.descripcion {{ repuesto.parte.description  }}
            td.cantidad {{ repuesto.cantidad  }}

      template(#modal-footer='{ ok, cancel, hide }')
        div.d-flex.w-100.justify-content-between
          b-button(size='sm' variant='secondary' @click='hideModal' :disabled="loading") Cancelar
            b-spinner(v-if="loading" small)
          b-button(size='sm' variant='primary' @click='recibirEjecutivo' :disabled="loading" id="ov-action-confirm-receive-parts") Confirmar
            b-spinner(v-if="loading" small)
  </template>
  <script>
  import { mapActions } from 'vuex'

  export default {
    name: 'RechazarCotizacion',
    data() {
      return {
        showModal: false,
        loading: false,
      }
    },
    props: {
      dataOv: {
        type: Object,
        required: true,
      },

    },
    methods: {
      ...mapActions('OVStore', ['receivePartsExecutive']),
      async recibirEjecutivo() {
        this.loading = true
        await this.receivePartsExecutive({ id_oportunidad_venta: this.dataOv?.id })
        this.$emit('reloadAll')
        this.loading = false
        this.hideModal()
      },
      openModal() {
        this.showModal = true
      },
      hideModal() {
        this.showModal = false
      },
    },
    computed: {
      repuestosParaRecibir() {
        return this.dataOv?.detalle_venta.filter(repuesto => repuesto.repuesto_disponiblidad)
      },
    },
  }
  </script>
  <style lang="scss" scoped>
  .center {
    text-align: center;
    width: 100%;
  }

  p.center{
    margin-top: 0;
    margin-bottom: 0.2rem;
    color: #525252;
  }
  .table,
  .table th,
  .table td {
      border: none;
      border-collapse: collapse;
      box-shadow: none;
      background-color: transparent;
      padding: 0.4rem;
      color: #525252
  }
  .table td.cantidad {
    text-align: right;
  }
  .table th.cantidad {
    text-align: right;
  }
  .table td.descripcion {
    text-align: left;
  }
  .table th.descripcion {
    text-align: left;
  }
  .table tr {
    color:#525252;
    height: 60px;
  }

  </style>
